import styled from '@emotion/styled'

import {Button} from '@vio/atlas/Button'
import {SkeletonLoader} from '@vio/atlas/SkeletonLoader'
import {SKELETON_BASE_COLOR} from '@vio/atlas/src/components/designSystem/SkeletonLoader'
import {cssTheme} from '@vio/atlas/themes'

import {buildGridGalleryGridArea} from './helpers'

export const StyledSkeletonLoader = styled(SkeletonLoader)`
  display: flex;
  width: 100%;

  > span {
    width: 100%;
  }
`

export const Container = styled.div`
  width: 100%;
  border-radius: ${cssTheme.layout.spacing.s400};
  overflow: hidden;
  position: relative;
`

export const Wrapper = styled.div<{height: number; mainColumnWidth?: string}>`
  height: ${({height}) => `${height}px`};
  display: grid;
  grid-column-gap: ${cssTheme.layout.spacing.s200};
  grid-row-gap: ${cssTheme.layout.spacing.s200};

  ${({mainColumnWidth}) => buildGridGalleryGridArea(mainColumnWidth)}
`

export const WrapperItem = styled.div`
  width: 100%;
  display: flex;
  position: relative;
  cursor: pointer;
  overflow: hidden;
  background-color: ${SKELETON_BASE_COLOR};

  &:after {
    content: '';
    background-color: rgba(0, 0, 0, 0.2);
    position: absolute;
    width: 100%;
    height: 100%;
    opacity: 0;
    transition: opacity 0.2s;
  }

  &:hover::after {
    opacity: 1;
  }
`

export const AllPhotosButton = styled(Button)`
  position: absolute;
  bottom: ${cssTheme.layout.spacing.s400};
  right: ${cssTheme.layout.spacing.s500};
`
